const SrcFilter = {
	filters: {
		media: function (media: {server: string, bucket: string, filename: string}) {
			if (!media || !media.server) return '';
			return `https://${media.server}/${media.bucket}/${media.filename}`
			// const value = value.toString()
			// return `${process.env.VUE_APP_baseURL}/media/get/${value}`
		},

		public_media_by_id: function (id: string) {
			return `${process.env.VUE_APP_blobURL}/public/${id}`
		}
	},
}

export {
	SrcFilter,
};